import { render, staticRenderFns } from "./PrimaryNavItem.vue?vue&type=template&id=59b99778&scoped=true&"
import script from "./PrimaryNavItem.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavItem.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryNavItem.vue?vue&type=style&index=0&id=59b99778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b99778",
  null
  
)

export default component.exports